/**
 *
 * Utils
 *
 */

export const sectionLinks = [
  {
    id: 1,
    path: "https://stage-consumer.doctall.com/dashboard",
    label: "Book a Doctor",
    color : "blue",

  },
  {
    id: 2,
    path: "/",
    label: "Diagnostics",
    color : "red",
  },
  // {
  //   id: 3,
  //   path: "/",
  //   label: "BioCheck",
  // },
  {
    id: 4,
    path: "https://doctall.com/pedia/",
    label: "Doctallpedia",
  },
  {
    id: 5,
    path: "https://doctall.com/living/",
    label: "Doctall Living",
  },
];

export const MOBsectionLinks = [
  {
    id: 1,
    path: "https://consumer.doctall.com/",
    label: "Book a Doctor",
  },
  {
    id: 2,
    path: "/",
    label: "Diagnostics",
  },
  // {
  //   id: 3,
  //   path: '/',
  //   label: 'BioCheck'
  // },
  {
    id: 4,
    path: "https://doctall.com/pedia/",
    label: "Doctallpedia",
  },
  {
    id: 5,
    path: "https://doctall.com/living/",
    label: "Doctall Living",
  },
];

export const mobilesectionLinks2 = [
  // {
  //   id: 1,
  //   path: "/",
  //   label: "Diagnostic Tests",
  //   view: "md",
  //   icon: require("../assets/images/sideDrop.svg").default,
  //   childRoutes: [
  //     {
  //       id: 1.1,
  //       path: "/populartest",
  //       label: "Pathology",
  //       icon: require("../assets/images/dropSys.svg").default,
  //     },
  //     {
  //       id: 1.2,
  //       path: "/populartest",
  //       label: "Radiology",
  //       icon: require("../assets/images/radiodrop.svg").default,
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   path: "/",
  //   view: "md",
  //   label: "BioCheck Panels",
  //   icon: require("../assets/images/sideDrop.svg").default,
  // },
];

export const sectionLinks2 = [
  // {
  //     id: 1,
  //     path: '/',
  //     label: 'Diagnostic Tests',
  //     icon: DownArrow,
  //     view: 'md',
  //     childRoutes: [
  //         {
  //             id: 1.1,
  //             path: '/',
  //             label: 'Pathology'
  //         },
  //         {
  //             id: 1.2,
  //             path: '/',
  //             label: 'Radiology'
  //         }
  //     ]
  // },
  // {
  //     id: 2,
  //     path: '/',
  //     view: 'md',
  //     label: 'BioCheck Panels',
  //     icon: DownArrow,
  //     childRoutes: [
  //         // {
  //         //     id: 2.1,
  //         //     path: '/',
  //         //     label: 'Link1'
  //         // },
  //         // {
  //         //     id: 2.2,
  //         //     path: '/',
  //         //     label: 'Link2'
  //         // },
  //         // {
  //         //     id: 2.3,
  //         //     path: '/',
  //         //     label: 'Link3'
  //         // }
  //     ]
  // },
  // {
  //     id: 3,
  //     path: '/',
  //     label: 'Find Partner Branch'
  // },
  {
    id: 4,
    path: "https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/",
    label: "Contact Us",
  },
];

export const footerLinks = [
  {
    id: 1,
    title: "PRODUCTS",
    routes: [
      // {
      //   id: 1.1,
      //   path: "/",
      //   label: "Bio Intels",
      // },
      {
        id: 1.2,
        path: "/populartest",
        label: "Popular Tests",
      },
      {
        id: 1.3,
        path: "https://consumer.doctall.com/",
        label: "Book a Doctor",
      },
      {
        id: 1.4,
        path: "https://doctall.com/homecare/",
        label: "Home Care",
      },
    ],
  },
  {
    id: 2,
    title: "CORPORATE",
    subroute: {
      id: 2,
      title: "RESOURCES",
      routes: [
        {
          id: 2.1,
          path: "https://doctall.com/pedia/",
          label: "Doctallpedia",
        },
        {
          id: 2.2,
          path: "https://doctall.com/living/",
          label: "Doctall Living",
        },
        {
          id: 2.3,
          path: "/",
          label: "Find Partner Branch",
        },
      ],
    },
    routes: [
      {
        id: 2.1,
        path: "https://doctall.com/doctallpro/",
        label: "Doctall Pro",
      },
    ],
  },

  {
    id: 3,
    title: "COMPANY",

    routes: [
      {
        id: 2.1,
        path: "https://doctall.com/about-us",
        label: "About Us",
      },
      {
        id: 2.2,
        path: "https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/",
        label: "Contact Us",
      },
      {
        id: 2.3,
        path: "https://doctall.com/",
        label: "Visit Doctall",
      },
      {
        id: 2.4,
        path: "/terms",
        label: "Terms & Conditions",
      },
    ],
  },
  {
    id: 4,
    title: "POLICIES",
    routes: [
      {
        id: 4.1,
        path: "https://doctall.com/cancel-and-refund",
        label:
          "Refund Policy - including policy to withhold all card holder information",
      },
      {
        id: 4.2,
        path: "/deliveryPage",
        label: "Delivery Policy",
      },
      {
        id: 4.3,
        path: "/cancellationRefundPolicy",
        label: "Cancellation Policy",
      },
      {
        id: 4.4,
        path: "/faq",
        label: "FAQs",
      },
    ],
  },
];

export const mobfooterLinks = [
  {
    id: 1,
    title: "PRODUCTS",
    routes: [
      // {
      //   id: 1.1,
      //   path: "/",
      //   label: "Bio Intels",
      // },
      {
        id: 1.2,
        path: "/",
        label: "Popular Tests",
      },
      {
        id: 1.3,
        path: "https://consumer.doctall.com/",
        label: "Book a Doctor",
      },
      {
        id: 1.4,
        path: "https://doctall.com/homecare/",
        label: "Home Care",
      },
      {
        id: 1.5,
        path: "https://doctall.com/doctallpro/",
        label: "Doctall Pro",
      },
    ],
  },
  {
    id: 3,
    title: "CORPORATE",
    routes: [
      {
        id: 2.1,
        path: "https://doctall.com/doctallpro/",
        label: "Doctall Pro",
      },
    ],
  },
  {
    id: 2,
    title: "POLICIES",
    subroute: {
      id: 5,
      title: "RESOURCES",
      routes: [
        {
          id: 2.1,
          path: "https://doctall.com/pedia/",
          label: "Doctallpedia",
        },
        {
          id: 2.2,
          path: "https://doctall.com/living/",
          label: "Doctall Living",
        },
        {
          id: 2.3,
          path: "/",
          label: "Find Partner Branch",
        },
      ],
    },
    routes: [
      {
        id: 4.1,
        path: "https://diagnostics.doctall.com/refundpolicy",
        label:
          "Refund Policy - incuding policy to withhold all card holder information",
      },
      {
        id: 4.2,
        path: "/deliveryPage",
        label: "Delivery Policy",
      },
      {
        id: 4.3,
        path: "/cancellationRefundPolicy",
        label: "Cancellation Policy",
      },
      {
        id: 4.4,
        path: "/faq",
        label: "FAQs",
      },
    ],
  },
  {
    id: 4,
    title: "COMPANY",
    routes: [
      {
        id: 3.1,
        path: "https://diagnostics.doctall.com/about-us",
        label: "About Us",
      },
      {
        id: 3.2,
        path: "https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/",
        label: "Contact Us",
      },
      {
        id: 3.3,
        path: "https://doctall.com/",
        label: "Visit Doctall",
      },
      {
        id: 3.3,
        path: "/terms",
        label: "Terms & Conditions",
      },
    ],
  },
];
